<script setup>
import { onMounted, ref } from "vue"
import { useRoute } from "vue-router"
import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"
import * as persianTools from "@persian-tools/persian-tools"

import store from "../../state/store"

import { useParseDiscountDetails } from "../../use/useParseDiscountDetails"

const title = "جزئیات بستانکاری فروشگاه"
const items = ref([
  {
    text: "فروشگاه ها",
    href: "/dashboard/stores",
  },
  {
    text: "جزئیات بستانکاری فروشگاه",
    active: true,
  },
])

const route = useRoute()
const storeId = route.params.storeId

const orderItemDetails = ref([])

onMounted(async () => {
  const { data } = await store.dispatch("getOrderItemsByStore", storeId)
  orderItemDetails.value = {
    ...data.data,
  }
})

const { parseDiscountDetails, formattedPrices } = useParseDiscountDetails()
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="storeCreditorDetailList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست محصولات تسویه نشده</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2"></div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table align-middle" id="storeCreditorDetailTable">
                  <thead class="table-light text-muted">
                    <tr>
                      <th class="sort" data-sort="product">جزئیات محصول</th>
                      <th class="sort" data-sort="original_price">قیمت</th>
                      <th class="sort" data-sort="quantity">تعداد</th>
                      <th class="sort" data-sort="discunt">تخفیف</th>
                      <th class="sort" data-sort="order_tracking_code">
                        شماره سفارش
                      </th>
                      <th class="sort" data-sort="price">مبلغ کل</th>
                    </tr>
                  </thead>

                  <tbody class="list">
                    <tr v-for="(item, index) of orderItemDetails" :key="index">
                      <td>
                        <div class="d-flex">
                          <div
                            class="flex-shrink-0 avatar-md bg-light rounded p-1"
                          >
                            <img
                              :src="item.product.image"
                              alt=""
                              class="img-fluid d-block"
                            />
                          </div>
                          <div class="flex-grow-1 ms-3">
                            <h5 class="fs-15">
                              <router-link to="" class="link-primary"
                                >{{ item.product.name }}
                              </router-link>
                            </h5>
                            <p
                              v-for="(value, index) of item.product.values"
                              :key="index"
                              class="text-muted mb-0"
                            >
                              {{ value.attributeName }}:
                              <span class="fw-medium">{{
                                value.valueName
                              }}</span>
                            </p>
                            <p
                              v-if="item.product.createdBy"
                              class="text-muted mb-0 mt-1"
                            >
                              <strong>فروشگاه: </strong>
                              <span class="fw-medium">{{
                                item.product.createdBy
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>{{ formattedPrices(item.originalPrice) }}</td>
                      <td>{{ persianTools.digitsEnToFa(item.qty) }}</td>
                      <td>
                        <div v-if="item.discountDetails">
                          <p
                            v-if="typeof item.discountDetails === 'string'"
                            v-html="parseDiscountDetails(item.discountDetails)"
                          ></p>
                          <p v-else>
                            <strong>نوع تخفیف:</strong>
                            {{ item.discountDetails.type }}<br />
                            <strong>مقدار تخفیف:</strong>
                            {{ item.discountDetails.amount }}<br />
                            <strong>درصد تخفیف:</strong>
                            {{ item.discountDetails.percent }}<br />
                            <strong>قیمت با تخفیف:</strong>
                            {{ item.discountDetails.priceWithDiscount }}
                          </p>
                        </div>

                        <!-- نمایش پیغام در صورتی که تخفیف موجود نباشد -->
                        <p v-else>تخفیف موجود نیست.</p>
                      </td>
                      <td>
                        {{ persianTools.digitsEnToFa(item.trackingCode) }}
                      </td>
                      <td class="fw-medium">
                        {{ formattedPrices(item.price) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
